import Bacon from 'baconjs'

export const logInAction = new Bacon.Bus()
export const logOutAction = new Bacon.Bus()
export const requestPasswordResetEmail = new Bacon.Bus()
export const resetPassword = new Bacon.Bus()
export const loadAuthStatus = new Bacon.Bus()
